import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { LikutService } from 'src/app/services/likut.service';
import { AdminTypes } from 'src/app/Interfaces/users';
import { CookieService } from 'ngx-cookie';
import { UserService } from 'src/app/services/user.service';
import { StorageService } from 'src/app/services/storage.service';
import { B2bService } from 'src/app/services/b2b.service';
import { LOGO_TO_DISPLAY } from 'src/startup';
import { MFAErrorResponse, MFASuccessResponse } from 'src/app/Interfaces/MFA-responses';
import { Subject, takeUntil } from 'rxjs';

@Component({
	selector: 'app-mfa',
	templateUrl: './mfa.component.html',
	styleUrls: ['./mfa.component.scss'],
})
export class MfaComponent implements OnInit, OnDestroy {
	_ss = inject(StoreService);
	router = inject(Router);
	private fb = inject(FormBuilder);
	private _likut = inject(LikutService);
	private _cookies = inject(CookieService);
	private _user = inject(UserService);
	private _storage = inject(StorageService);
	private _b2b = inject(B2bService);

	constructor() {}

	form = this.fb.nonNullable.group({
		mfaPassword: ['', Validators.required],
	});

	online;

	Loading = false;
	ServerProblem = false;

	Privacy = false;

	isLocalhost;

	cookieState: Record<string, string>;
	get skipPasswordCheckAndLoginCheck() {
		return this.cookieState['skipPassword'];
	}

	logo = LOGO_TO_DISPLAY;

	errorMessage = '';

	destroy$ = new Subject<void>();

	ngOnInit(): void {
		this.form.controls.mfaPassword.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
			this.errorMessage = '';
		});

		const { agent, customerNumber, mobilityPassword } = this._ss.mfaInfo;

		if (!agent || !customerNumber || !mobilityPassword) {
			this.router.navigate(['login']);
			return;
		}

		this.online = window.navigator.onLine;

		this.isLocalhost = !!location?.href?.includes('localhost');

		window.scrollTo(0, 0);

		if (localStorage.getItem('UserName') !== null && localStorage.getItem('AgentId') !== null) {
			this._ss.UserNameConnected = localStorage.getItem('UserName');
			this._ss.AgentIdConnected = localStorage.getItem('AgentId');

			this.router.navigate(['home'], { replaceUrl: true });
		}

		this.refreshCookieState();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	async Login(bool = false) {
		this.errorMessage = '';
		this.online = window.navigator.onLine;

		const mfaPassword = this.form.controls.mfaPassword.value;

		if (!mfaPassword) {
			this.errorMessage = 'יש להזין סיסמה';
			return;
		}

		this.Loading = true;

		if (!this.online) {
			alert('אינך מחובר לאינטרנט, אנא בדוק את הגדרות מכשירך');
			this.Loading = false;
			return;
		}

		const { agent, customerNumber, mobilityPassword } = this._ss.mfaInfo;

		this._ss.loginWithMFA({ custnum: customerNumber.trim(), agent, mobilityPassword, mfaPassword }).subscribe({
			next: async (res: MFASuccessResponse) => {
				if (typeof res === 'string') {
					alert('תקלה בשרת');
					this.Loading = false;
					return;
				}

				this._ss.CustomerInformation = res.customer;
				const verifiedUser = res.user.recordset[0];

				this._ss.UserNameConnected = verifiedUser.UserName;
				this._ss.AgentIdConnected = verifiedUser.AgentID;

				this._likut.Admin = verifiedUser.Admin as AdminTypes;

				this._likut.handleLikutInit();
				this._b2b.refreshAdmin(verifiedUser.Admin);

				const hasWhatsappNumber = this._ss.CustomerInformation?.WhatsappB2BL && this._ss.CustomerInformation.WhatsappB2BL !== '0' && verifiedUser.Admin.includes('b2bL');

				this._ss.hasWhatsappIcon$.next(hasWhatsappNumber);
				if (hasWhatsappNumber) {
					this._ss.whatsappNumber$.next(this._ss.CustomerInformation.WhatsappB2BL);
				}

				this._storage.storeUserParameters({ verifiedUser, webclientInfo: this._ss.CustomerInformation });

				if (verifiedUser.Email) {
					this._user.updateEmail(verifiedUser.Email);
				}

				this._ss.UpdateUserLoggedConnect({ AgentID: this._ss.AgentIdConnected }).subscribe(res => {
					this.router.navigate(['home']);
				});
			},
			error: err => {
				console.log(err);
				switch ((err.error as MFAErrorResponse).message) {
					case 'Invalid mfaPassword':
						this.errorMessage = 'סיסמה שגויה';
						break;
					case 'Missing agent, mobilityPassword, custnum or mfaPassword':
					case 'Failed to login':
						this.errorMessage = 'תקלה בשרת';
						break;
					default:
						this.errorMessage = 'לא ניתן להתחבר בעת זו';
						break;
				}

				this.Loading = false;
			},
		});
	}

	public MoveToPrivacy() {
		this.router.navigate(['privacy']);
	}

	private refreshCookieState() {
		this.cookieState = this._cookies.getAll();
	}
}
